const AVATAR_COLORS = Object.freeze([
  'light-success',
  'light-danger',
  'light-warning',
  'light-info',
  'light-primary',
  'light-secondary'
])

const FALLBACK_INITIALS = '?'
const MAX_INITIALS = 2

export const avatarColorFor = (key) => {
  if (!key) return AVATAR_COLORS[0]
  let hash = 0
  for (let i = 0; i < key.length; i++) {
    hash = Math.trunc((hash * 31) + key.codePointAt(i))
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

export const getInitials = (value) => {
  if (!value || typeof value !== 'string') return FALLBACK_INITIALS
  const words = value.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return FALLBACK_INITIALS
  if (words.length === 1) return words[0].charAt(0).toUpperCase()
  const first = words[0].charAt(0)
  const last = words.at(-1).charAt(0)
  return (first + last).slice(0, MAX_INITIALS).toUpperCase()
}
